
document.addEventListener('DOMContentLoaded', function () {
    var controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            reverse: true,
        },
    });
    // sc3
    var s3_animate = new TimelineLite();
    var _ref = [
        TweenMax.to('.img_front', 0.8, {
            y: '-20%',
        }),
        TweenMax.to('.img_behind', 0.8, {
            y: '10%',
        }),
    ],
        s3_tween1 = _ref[0],
        s3_tween2 = _ref[1];

    s3_animate.add([s3_tween1, s3_tween2], 0);

    new ScrollMagic.Scene({
        triggerElement: '.GD-banner_image-container',
        triggerHook: 1,
        duration: '250%',
        offset: 0,
    })
        .setTween(s3_animate)
        .addTo(controller);
});
